import React from 'react';

import { SORT_DIRECTION } from '../../../types';
import { FILTERS_UNION, ORDERS_FILTERS_TYPE } from '../types';

import OrdersHeaderItem from './orders-header-item';

import './orders-header.scss';

const ordersField = [
  {
    id: 'refNumber',
    title: '№',
    toggle: true,
  },
  {
    id: 'contr-agent',
    title: 'Контрагент',
    toggle: false,
  },
  {
    id: 'INN',
    title: 'ИНН',
    toggle: false,
  },
  {
    id: 'made-of',
    title: 'Исполенно',
    toggle: false,
  },
  {
    id: 'amount',
    title: 'Сумма',
    toggle: true,
  },
  {
    id: 'period',
    title: 'Дата создания',
    toggle: true,
  },
  {
    id: 'status',
    title: 'Статус',
    toggle: false,
  },
];

interface OrdersHeaderProps {
  filters: ORDERS_FILTERS_TYPE;
  onFilterChange: (name: FILTERS_UNION, direction: SORT_DIRECTION) => void;
}

const OrdersHeader: React.FC<OrdersHeaderProps> = ({
  filters,
  onFilterChange,
}) => {
  const getDirection = (name: FILTERS_UNION) => {
    if (
      ordersField
        .filter((item) => item.toggle)
        .map((item) => item.id)
        .includes(name)
    ) {
      return filters[name].direction as SORT_DIRECTION;
    }
    return undefined;
  };

  return (
    <div className="orders__header">
      {ordersField.map((item) => (
        <OrdersHeaderItem
          direction={getDirection(item.id as FILTERS_UNION)}
          onChangeToggle={
            item.toggle
              ? (direction) => {
                  onFilterChange(item.id as FILTERS_UNION, direction);
                }
              : undefined
          }
          key={item.id}
          title={item.title}
          toggle={item.toggle}
        />
      ))}
    </div>
  );
};
export default OrdersHeader;
